export default __webpack_public_path__ + "static/media/acceptInstructions.23ace67a.gif";